"use strict";
import _ from "lodash";

import breadCrumbsTemplate from "./breadcrumbsTemplate";
import indexDocTemplate from "./indexTemplate";

var DocStates = function ($stateProvider, $urlRouterProvider, $injector) {
    $stateProvider

        .state("docs", {
            url: "/docs",

            views: {
                breadcrumb: {},
                "": {
                    template: indexDocTemplate,
                    controller: "DocsController as vm"
                }
            }
        })

        .state("docs.page", {
            url: "/{page}",
            views: {
                "breadcrumb@docs": {
                    template: breadCrumbsTemplate,
                    resolve: {
                        page: [
                            "$stateParams",
                            "DocsLinksService",
                            function ($stateParams, DocsLinksService) {
                                var docPage = _.find(DocsLinksService, { name: $stateParams.page });
                                return docPage
                                    ? _.get(
                                          docPage,
                                          "breadcrumb",
                                          _.get(docPage, "text", $stateParams.page)
                                      )
                                    : $stateParams.page;
                            }
                        ]
                    },
                    controller: [
                        "$scope",
                        "page",
                        function ($scope, page) {
                            $scope.page = page;
                        }
                    ]
                },
                "": {
                    templateProvider: [
                        "$http",
                        "$stateParams",
                        "DocsLinksService",
                        "$injector",
                        function ($http, $stateParams, DocsLinksService, $injector) {
                            return _.find(DocsLinksService, { name: $stateParams.page }).template;
                        }
                    ]
                }
            }
        })

        .state("docs.file", {
            url: "/file/{file}"
        });
};

DocStates.$inject = ["$stateProvider", "$urlRouterProvider", "$injector"];
export default DocStates;
